import HttpError from 'core/exceptions/httpError';

export default class HttpUnauthorized extends HttpError {}
